import { mergeStyles } from '@fluentui/react/lib/Styling';
import { getMonthItemContentStyles } from 'owa-calendar-surface-dategrid/lib/surfaceItems/CalendarSurfaceItemComponentRenderer';
import type {
    CalendarMonthSurfaceItemStyleProps,
    CalendarMonthSurfaceItemStyles,
} from './CalendarMonthSurfaceItem.types';
import surfaceFocusStyles from 'owa-calendar-surface-dategrid/lib/utils/surfaceFocusStyles';

export const getStyles = (
    props: CalendarMonthSurfaceItemStyleProps
): CalendarMonthSurfaceItemStyles => {
    const { className, theme, freeBusyType, responseType, colorScheme, useBoldTheme } = props;

    return {
        root: [
            mergeStyles(
                className,
                theme ? surfaceFocusStyles('relative', theme, useBoldTheme) : undefined,
                {
                    width: '100%',
                }
            ),
        ],
        content: getMonthItemContentStyles(freeBusyType, responseType, colorScheme, useBoldTheme),
        agendaContent: {
            marginTop: 1,
        },
    };
};
